import { Component } from '@angular/core';
import { TransferHttpService } from '../../services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';

@Component({
  selector: 'view-drawings',
  templateUrl: './viewDrawings.component.html'
})

export class ViewDrawingsComponent {

  // AimsCommonTable setup
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'details', label: 'Details', type: 'button', prefix: '/projectSupport/drawing/', linkId: 'cadDrawingId',
      hidden: !this.permissions.canRead(this.permissions.ComponentID.Drawing), filter: false },
    { key: 'deleteButton', label: 'Delete', type: 'button', filter: false,
      hidden: !this.permissions.canDelete(this.permissions.ComponentID.Drawing),
      events: { click: (element) => this.deleteDrawing(element.cadDrawingId) } },
    { key: 'drawingStatusName', label: 'Status', type: 'dynamic',  filterType: 'dynamic',
      events: { filterAndSortCompare: (term, el) => { term == el.drawingStatusName } } },
    { key: 'drawingFormatName', label: 'Format', type: 'dynamic',  filterType: 'dynamic',
      events: { filterAndSortCompare: (term, el) => { term == el.drawingFormatName } } },
    { key: 'drawingNum', label: 'Drawing Number', type: 'string' },
    { key: 'drawingTitle', label: 'Title', type: 'string' },
    { key: 'pageNum', label: 'Sheet #', type: 'string' },
    { key: 'referenceNum', label: 'Ref #', type: 'string' },
    { key: 'siteName', label: 'Site', type: 'dynamic',  filterType: 'dynamic',
      events: { filterAndSortCompare: (term, el) => { term == el.siteName } } },
    { key: 'discipline', label: 'Discipline', type: 'dynamic',  filterType: 'dynamic',
      events: { filterAndSortCompare: (term, el) => { term == el.discipline } } },
    { key: 'drawingType', label: 'Type', type: 'string' },
    { key: 'buildingNumber', label: 'Building Num', type: 'string' },
    { key: 'assignedDrafter', label: 'Assigned Drafter', type: 'dynamic',  filterType: 'dynamic',
      events: { filterAndSortCompare: (term, el) => { term == el.fullName } } },
    { key: 'originalPageNum', label: 'Orig Page #', type: 'string' },
    { key: 'originalDrawingNum', label: 'Orig Drawing #', type: 'string' },
    { key: 'reviewedBy', label: 'Reviewed By', type: 'dynamic',  filterType: 'dynamic',
      events: { filterAndSortCompare: (term, el) => { term == el.fullName } } },
  ];
  tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false
  };

  constructor(public transferHttp: TransferHttpService,
    public permissions: PermissionsService) {
  }

  //***************************
  // Variables
  //***************************

  user = this.transferHttp.getCache("user");

  employeeValues = this.transferHttp.getCache('employeeDropdown');
  statusValues = this.transferHttp.getHot('ProjectSupport/GetDrawingStatuses');
  formatValues = this.transferHttp.getHot('ProjectSupport/GetDrawingFormats');
  disciplineValues = this.transferHttp.getHot('ProjectSupport/GetDrawingDisciplines');
  sitesValues = this.transferHttp.getCache('sitesDropdown');

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  //Main Grid
  drawings = this.transferHttp.getHot('ProjectSupport/GetDrawings');

  //***************************
  // Functions
  //***************************

  deleteDrawing(drawingId: number) {
    if (confirm("This will PERMANENTLY delete this record.  I'm not kidding.  Are you sure?")) {
      this.spinnerText = "Deleting...";
      this.showSpinner = true;
      this.transferHttp.delete(`ProjectSupport/DeleteDrawing?drawingId=${drawingId}`).subscribe(r => {
        this.drawings = this.transferHttp.getHot('ProjectSupport/GetDrawings');
        this.showSpinner = false;
      });
    }
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
  }

}
